import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { MainSalary } from './MainSalary';

export class OtherSalary extends MainSalary {
    _originalTypeClassName = "zERP.BO.OtherSalary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OtherSalary.translate = translateService;
}
super();
this.ExpressionTemplate = null;
this.CalculationFormula = null;
this.MultiplierA = null;
this.MultiplierB = null;
this.Multiplier = 1;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
ExpressionTemplate:any;
CalculationFormula:any;
MultiplierA:any;
MultiplierB:any;
Multiplier:any;

static CalculateMultiplierA($this: any, payrollData: any,userInput: any): any{return userInput;
}
static GetClassNameOther(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}